import BAccordion from './BAccordion/BAccordion.vue'
import BAccordionItem from './BAccordion/BAccordionItem.vue'
import BAlert from './BAlert.vue'
import BAvatar from './BAvatar/BAvatar.vue'
import BAvatarGroup from './BAvatar/BAvatarGroup.vue'
import BBadge from './BBadge/BBadge.vue'
import BBreadcrumb from './BBreadcrumb/BBreadcrumb.vue'
import BBreadcrumbItem from './BBreadcrumb/BBreadcrumbItem.vue'
import BButton from './BButton/BButton.vue'
import BButtonGroup from './BButton/BButtonGroup.vue'
import BButtonToolbar from './BButton/BButtonToolbar.vue'
import BCloseButton from './BButton/BCloseButton.vue'
import BCard from './BCard/BCard.vue'
import BCardBody from './BCard/BCardBody.vue'
import BCardFooter from './BCard/BCardFooter.vue'
import BCardGroup from './BCard/BCardGroup.vue'
import BCardHeader from './BCard/BCardHeader.vue'
import BCardImg from './BCard/BCardImg.vue'
import BCardSubtitle from './BCard/BCardSubtitle.vue'
import BCardText from './BCard/BCardText.vue'
import BCardTitle from './BCard/BCardTitle.vue'
import BCarousel from './BCarousel/BCarousel.vue'
import BCarouselSlide from './BCarousel/BCarouselSlide.vue'
import BCol from './BCol.vue'
import BCollapse from './BCollapse.vue'
import BContainer from './BContainer.vue'
import BDropdown from './BDropdown/BDropdown.vue'
import BDropdownDivider from './BDropdown/BDropdownDivider.vue'
import BDropdownForm from './BDropdown/BDropdownForm.vue'
import BDropdownGroup from './BDropdown/BDropdownGroup.vue'
import BDropdownHeader from './BDropdown/BDropdownHeader.vue'
import BDropdownItem from './BDropdown/BDropdownItem.vue'
import BDropdownItemButton from './BDropdown/BDropdownItemButton.vue'
import BDropdownText from './BDropdown/BDropdownText.vue'
import BForm from './BForm/BForm.vue'
import BFormFloatingLabel from './BForm/BFormFloatingLabel.vue'
import BFormInvalidFeedback from './BForm/BFormInvalidFeedback.vue'
import BFormRow from './BForm/BFormRow.vue'
import BFormText from './BForm/BFormText.vue'
import BFormValidFeedback from './BForm/BFormValidFeedback.vue'
import BFormCheckbox from './BFormCheckbox/BFormCheckbox.vue'
import BFormCheckboxGroup from './BFormCheckbox/BFormCheckboxGroup.vue'
import BFormGroup from './BFormGroup/BFormGroup.vue'
import BFormInput from './BFormInput/BFormInput.vue'
import BFormRadio from './BFormRadio/BFormRadio.vue'
import BFormRadioGroup from './BFormRadio/BFormRadioGroup.vue'
import BFormSelect from './BFormSelect/BFormSelect.vue'
import BFormSelectOption from './BFormSelect/BFormSelectOption.vue'
import BFormSelectOptionGroup from './BFormSelect/BFormSelectOptionGroup.vue'
import BFormTag from './BFormTags/BFormTag.vue'
import BFormTags from './BFormTags/BFormTags.vue'
import BFormTextarea from './BFormTextarea/BFormTextarea.vue'
import BImg from './BImg.vue'
import BInputGroup from './BInputGroup/BInputGroup.vue'
import BInputGroupAddon from './BInputGroup/BInputGroupAddon.vue'
import BInputGroupAppend from './BInputGroup/BInputGroupAppend.vue'
import BInputGroupPrepend from './BInputGroup/BInputGroupPrepend.vue'
import BInputGroupText from './BInputGroup/BInputGroupText.vue'
import BLink from './BLink/BLink.vue'
import BListGroup from './BListGroup/BListGroup.vue'
import BListGroupItem from './BListGroup/BListGroupItem.vue'
import BModal from './BModal.vue'
import BNav from './BNav/BNav.vue'
import BNavForm from './BNav/BNavForm.vue'
import BNavItem from './BNav/BNavItem.vue'
import BNavItemDropdown from './BNav/BNavItemDropdown.vue'
import BNavText from './BNav/BNavText.vue'
import BNavbar from './BNavbar/BNavbar.vue'
import BNavbarBrand from './BNavbar/BNavbarBrand.vue'
import BNavbarNav from './BNavbar/BNavbarNav.vue'
import BNavbarToggle from './BNavbar/BNavbarToggle.vue'
import BOffcanvas from './BOffcanvas.vue'
import BOverlay from './BOverlay/BOverlay.vue'
import BPagination from './BPagination/BPagination.vue'
import BPlaceholder from './BPlaceholder/BPlaceholder.vue'
import BPlaceholderButton from './BPlaceholder/BPlaceholderButton.vue'
import BPlaceholderCard from './BPlaceholder/BPlaceholderCard.vue'
import BPlaceholderTable from './BPlaceholder/BPlaceholderTable.vue'
import BPlaceholderWrapper from './BPlaceholder/BPlaceholderWrapper.vue'
import BPopover from './BPopover.vue'
import BProgress from './BProgress/BProgress.vue'
import BProgressBar from './BProgress/BProgressBar.vue'
import BRow from './BRow.vue'
import BSkeleton from './BSkeleton/BSkeleton.vue'
import BSkeletonIcon from './BSkeleton/BSkeletonIcon.vue'
import BSkeletonTable from './BSkeleton/BSkeletonTable.vue'
import BSkeletonWrapper from './BSkeleton/BSkeletonWrapper.vue'
import BSpinner from './BSpinner.vue'
import BTable from './BTable/BTable.vue'
import BTableSimple from './BTable/BTableSimple.vue'
import BTbody from './BTable/BTbody.vue'
import BTd from './BTable/BTd.vue'
import BTfoot from './BTable/BTfoot.vue'
import BTh from './BTable/BTh.vue'
import BThead from './BTable/BThead.vue'
import BTr from './BTable/BTr.vue'
import BTab from './BTabs/BTab.vue'
import BTabs from './BTabs/BTabs.vue'
import {BToast, BToaster, BToastPlugin} from './BToast'
import BToastContainer from './BToast/BToaster.vue'
import BTransition from './BTransition/BTransition.vue'

export default {
  BAccordion,
  BAccordionItem,
  BNavText,
  BAlert,
  BAvatar,
  BAvatarGroup,
  BNavForm,
  BBadge,
  BBreadcrumb,
  BBreadcrumbItem,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardFooter,
  BCardGroup,
  BCardHeader,
  BCardImg,
  BCardSubtitle,
  BCardText,
  BCardTitle,
  BCarousel,
  BCarouselSlide,
  BCloseButton,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownHeader,
  BDropdownItem,
  BDropdownItemButton,
  BDropdownText,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFloatingLabel,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadio,
  BFormRadioGroup,
  BFormRow,
  BFormSelect,
  BFormSelectOption,
  BFormSelectOptionGroup,
  BFormText,
  BFormTextarea,
  BFormTag,
  BFormTags,
  BFormValidFeedback,
  BImg,
  BInputGroup,
  BInputGroupAddon,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroupText,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BNav,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavbarToggle,
  BNavItem,
  BNavItemDropdown,
  BOffcanvas,
  BOverlay,
  BPagination,
  BPlaceholder,
  BPlaceholderButton,
  BPlaceholderCard,
  BPlaceholderTable,
  BPlaceholderWrapper,
  BPopover,
  BProgress,
  BProgressBar,
  BRow,
  BSkeleton,
  BSkeletonIcon,
  BSkeletonTable,
  BSkeletonWrapper,
  BSpinner,
  BTab,
  BTable,
  BTableSimple,
  BTbody,
  BTd,
  BTfoot,
  BTh,
  BThead,
  BTr,
  BToast,
  BToaster,
  BToastContainer,
  BTabs,
  BTransition,
  BToastPlugin,
}
